// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"Timer_outerContainer__1FdIh","container":"Timer_container__VrlBB","middle":"Timer_middle__2HZKE","time":"Timer_time__3saDq"};